const storageKey = 'atum-remote.tab.v1';
const continuationKey = 'atum-remote.tab-continuation.v1';
const validKey = /^[A-Za-z0-9_-]{43}$/;
let loaded = false;
let key: string | undefined;

/** Cookies alone cannot authenticate a newly opened or restored tab. */
export function browserTabKey(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  if (loaded) return key;
  loaded = true;
  try {
    const navigation = performance.getEntriesByType('navigation')[0] as
      | PerformanceNavigationTiming
      | undefined;
    sessionStorage.removeItem(continuationKey);
    const stored = sessionStorage.getItem(storageKey);
    if (navigation?.type === 'reload' && stored && validKey.test(stored)) key = stored;
    else sessionStorage.removeItem(storageKey);
  } catch {
    // Sign-in reports an actionable error if tab storage is unavailable.
  }
  return key;
}

export function beginBrowserSignIn(): string {
  browserTabKey();
  clearBrowserTab();
  key = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32))))
    .replaceAll('+', '-')
    .replaceAll('/', '_')
    .replaceAll('=', '');
  return key;
}

/** The pending proof stays only in this document until its own sign-in succeeds. */
export function persistBrowserTab(expected: string) {
  if (key !== expected) throw new Error('Sign-in was cancelled. Try again.');
  try {
    sessionStorage.setItem(storageKey, expected);
  } catch {
    throw new Error('Tab storage is required to complete sign-in. Enable it and try again.');
  }
}

export function navigateBrowserTab(target: string) {
  if (!browserTabKey()) return;
  const url = new URL(target, location.origin);
  if (url.origin !== location.origin) throw new Error('Invalid browser navigation.');
  // Reload the same browsing context at the new app location. A copied tab still
  // starts with a fresh navigation, without a copyable continuation exception.
  window.history.pushState(null, '', url.href);
  window.location.reload();
}

export function clearBrowserTab() {
  key = undefined;
  try {
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem(continuationKey);
  } catch {
    /* The in-memory authority is still cleared. */
  }
}

export function browserTabHeaders(): Record<string, string> {
  const value = browserTabKey();
  return value ? { 'X-Atum-Remote-Tab': value } : {};
}

export function browserTabProtocols(): string[] {
  const value = browserTabKey();
  return value ? ['atum-remote-tab', value] : [];
}
